import './HeaderBar.css';
import CompanyLogo from './../../../assets/images/main-logo.png';
import { useEffect, useState } from "react";
import { getDomainFromUrl } from '../../../utils/domainUtilities';

const HeaderBar = () => {

    const [headerBox, setHeaderBox] = useState(null);
    const DefaultBox = (
        <header>
            <nav className="navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white border-bottom animate slide delay-1">
                <div className="container w-max1 ">
                    <div className="navbar-header animate slide delay-2">
                        <img src={CompanyLogo} title="Company Logo" alt="Company Logo" />
                    </div>
                    <div className="sestagline animate slide delay-3">
                        <div className="taglineMain">Simple, Secure, and Seamless Healthcare Communications</div>
                        <div className="directURL" hidden>sestest.direct-address.com { /*Domain should only be shown here for non branding site*/}</div>
                    </div>
                </div>
            </nav>
        </header>
    );

    useEffect(() => {
        const initializeHeaderBar = async () => {
            try {
                const customHeaderBar = await import(
                    "../../../custom_portal/" + getDomainFromUrl(window.location.hostname) + "/components/home/HeaderBar/HeaderBar"
                );

                setHeaderBox(customHeaderBar.default());
            } catch {
                setHeaderBox(DefaultBox);
            }
        };

        initializeHeaderBar();
    }, []);

    return <div>{headerBox}</div>;
};

export default HeaderBar;